export const updateTeam = {
  bib_number: {
    length: {
      maximum: 5,
    },
  },
};
